import { call, put } from "redux-saga/effects";

function* httpErrorHelpers(error, action, ignoreToast = false) {
    if (error.response) {
        yield call(
            handleAPIResponseError,
            error.response,
            error.message,
            ignoreToast
        );
        
    }

    const status = error.response ? error.response.status : null;
    yield put(action(error.message, status));
}

function* handleAPIResponseError(errorResponse, errorMessage, ignoreToast) {}

export default httpErrorHelpers;
